// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getMarkerLocation($$location) {
  if ($$location.TAG === /* WithTime */0) {
    return $$location._0.point;
  } else {
    return $$location._0;
  }
}

function getRouteLatLngArray(routes) {
  if (routes !== undefined) {
    return $$Array.map((function (a) {
                  return a.point;
                }), routes.line);
  } else {
    return [];
  }
}

function getWaypointsLatLngArray(waypoints) {
  if (waypoints !== undefined) {
    return $$Array.map((function (a) {
                  return getMarkerLocation(a.location);
                }), waypoints);
  } else {
    return [];
  }
}

function getLocationBounds(order_details) {
  return $$Array.append(getRouteLatLngArray(order_details.driver_route), $$Array.append(getWaypointsLatLngArray(order_details.locations.waypoint_locs), $$Array.append(Belt_Option.mapWithDefault(order_details.locations.trip_ended_loc, [], (function (x) {
                            return [getMarkerLocation(x.location)];
                          })), $$Array.append(Belt_Option.mapWithDefault(order_details.locations.trip_started_loc, [], (function (x) {
                                return [getMarkerLocation(x.location)];
                              })), $$Array.append(Belt_Option.mapWithDefault(order_details.locations.accepted_loc, [], (function (x) {
                                    return [getMarkerLocation(x)];
                                  })), [
                              getMarkerLocation(order_details.locations.pickup_loc.location),
                              getMarkerLocation(order_details.locations.drop_loc.location)
                            ])))));
}

export {
  getMarkerLocation ,
  getRouteLatLngArray ,
  getWaypointsLatLngArray ,
  getLocationBounds ,
  
}
/* No side effect */
